import React, { useEffect, useRef, useState } from "react";
import BaseUrl from "./Baseurl/Api.js";

const VideoGrid = () => {
  const [videos, setVideos] = useState([]);
  const [pageTitle] = useState("Shop from Video");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const scrollRef = useRef(null);
  const autoScrollTimer = useRef(null);
  const isHovered = useRef(false);

  // Fetch videos
  useEffect(() => {
    BaseUrl.get("/api/get_videopage")
      .then((response) => {
        if (response.data.status === "success") {
          setVideos(response.data.video);
        }
      })
      .catch((error) => console.error("Error fetching videos:", error));
  }, []);

  // Auto scroll
  useEffect(() => {
    const wrapper = scrollRef.current;
    if (!wrapper) return;

    const startAuto = () => {
      stopAuto();
      autoScrollTimer.current = setInterval(() => {
        if (isHovered.current) return;

        const card = wrapper.querySelector(".card-item");
        const gap = 24;
        const amount = (card ? card.offsetWidth : wrapper.clientWidth * 0.7) + gap;

        if (wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 10) {
          wrapper.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          wrapper.scrollBy({ left: amount, behavior: "smooth" });
        }
      }, 3000);
    };

    const stopAuto = () => {
      if (autoScrollTimer.current) {
        clearInterval(autoScrollTimer.current);
        autoScrollTimer.current = null;
      }
    };

    startAuto();
    return () => stopAuto();
  }, [videos]);

  // Hover pause
  const handleMouseEnter = () => (isHovered.current = true);
  const handleMouseLeave = () => (isHovered.current = false);

  // Manual scroll
  const scrollByCard = (dir = "right") => {
    const wrapper = scrollRef.current;
    const card = wrapper.querySelector(".card-item");
    const gap = 24;
    const amount = (card ? card.offsetWidth : wrapper.clientWidth * 0.7) + gap;
    wrapper.scrollBy({ left: dir === "right" ? amount : -amount, behavior: "smooth" });
  };

  // Modal
  const openModal = (video) => {
    setSelectedVideo(video);
    setIsModalOpen(true);
    isHovered.current = true;
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
    isHovered.current = false;
    document.body.style.overflow = "";
  };

  return (
    <>
      {/* ------------------- STYLES -------------------- */}
      <style>{`
        :root {
          --bg:#0f1720;
          --card:#0f1728;
          --accent:#66f27b;
        }

        .video-section {
          background: linear-gradient(180deg, var(--bg) -20%, #abf597ff 100%);
          color: #e6eef6;
          padding: 30px 12px;
          border-radius: 12px;
        }

        .header-row {
                 display: flex;
                 flex-direction: column;  
                 align-items: center;
                 justify-content: center;
                 gap: 8px;  
                 margin-bottom: 12px;
               }


        .product-title {
          font-size: 28px;
          font-weight: 700;
          color: #e8fdf0;
        }

        .carousel-wrap {
          position: relative;
          margin-top: 6px;
        }

        /* SCROLL AREA */
        .scroll-wrapper {
          display: flex;
          gap: 24px;
          padding: 18px;
          padding-left: 6px;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scrollbar-width: none;
        }
        .scroll-wrapper::-webkit-scrollbar { display: none; }

        /* CARD */
        .card-item {
          width: 300px;
          flex-shrink: 0;
          scroll-snap-align: start;
          border-radius: 14px;
          padding-bottom: 18px;
          transition: transform 0.32s ease, box-shadow 0.32s ease;
          cursor: pointer;
        }

        /* HOVER — NO BLUR, NO OVERLAY */
        .card-item:hover {
          transform: translateY(-8px) scale(1.01);
          box-shadow: 0 18px 40px rgba(2,6,23,0.6);
        }

        .card-item::after {
          display:none !important;  /* removing blur layer */
        }

        .video {
          width: 100%;
          height: 430px;
          object-fit: cover;
          border-radius: 12px;
        }

        .icon-container {
          position: absolute;
          bottom: -50px;
          left: 50%;
          transform: translateX(-50%);
          width: 86px;
          height: 86px;
          opacity: 0;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }
        .card-item:hover .icon-container {
          opacity: 1;
          transform: translateX(-50%) translateY(-6px);
        }

        .product-icon {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid rgba(255,255,255,0.1);
        }

        .product-name {
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          margin-top: 58px;
          color: #0c0d0cff;
        }

        /* ARROWS */
        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 46px;
          height: 46px;
          border-radius: 10px;
          background: rgba(255,255,255,0.05);
          cursor: pointer;
          display:flex;
          align-items:center;
          justify-content:center;
          z-index:10;
        }

        .arrow-left { left: 8px; }
        .arrow-right { right: 8px; }

        /* MODAL */
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .modal-card {
          width: min(1100px, 96%);
          max-height: 90vh;
          overflow: auto;
          background: #0f1728;
          border-radius: 14px;
          padding: 16px;
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 14px;
        }

        .modal-video {
          width:100%;
          border-radius:10px;
          height: 60vh;
          object-fit: cover;
        }

        .modal-side {
          padding: 12px;
          display:flex;
          flex-direction: column;
          gap: 14px;
        }

        .modal-thumb {
          width: 100%;
          height: 220px;
          object-fit: cover;
          border-radius: 10px;
        }

        .close-btn {
          position:absolute;
          top:10px;
          right:10px;
          width:40px;
          height:40px;
          border-radius:8px;
          background:#00000055;
          color:white;
          cursor:pointer;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        @media (max-width: 700px) {
          .card-item { width: 78%; }
          .video { height: 360px; }
          .arrow { display:none; }
          .modal-card { grid-template-columns: 1fr; }
        }
      `}</style>

      {/* ------------------- HTML -------------------- */}
      <div className="video-section">
        <div className="header-row">
          <h2 className="product-title">{pageTitle}</h2>
          <img
            src="https://ueirorganic.com/cdn/shop/t/39/assets/svg_title.svg"
            alt="underline"
             style={{ width: "270px", height: "auto" }}
          />
        </div>

        {/* CAROUSEL */}
        <div className="carousel-wrap" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <button className="arrow arrow-left" onClick={() => scrollByCard("left")}>
            <svg viewBox="0 0 24 24"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
          </button>

          <div className="scroll-wrapper" ref={scrollRef}>
            {videos.map((video) => (
              <div key={video.id} className="card-item" onClick={() => openModal(video)}>
                <div className="card-top" style={{ position: "relative" }}>
                  <video
                    src={`${BaseUrl.defaults.baseURL}/productimage/${video.video}`}
                    autoPlay muted loop playsInline
                    className="video"
                  />
                  <div className="icon-container">
                    <img
                      src={`${BaseUrl.defaults.baseURL}/productimage/${video.image}`}
                      className="product-icon"
                    />
                  </div>
                </div>
                <p className="product-name">{video.title}</p>
              </div>
            ))}
          </div>

          <button className="arrow arrow-right" onClick={() => scrollByCard("right")}>
            <svg viewBox="0 0 24 24"><path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>
          </button>
        </div>
      </div>

      {/* MODAL */}
      {isModalOpen && selectedVideo && (
        <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && closeModal()}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div style={{ position: "relative" }}>
              <video
                src={`${BaseUrl.defaults.baseURL}/productimage/${selectedVideo.video}`}
                controls autoPlay className="modal-video"
              />
              <button className="close-btn" onClick={closeModal}>✕</button>
            </div>

            <div className="modal-side">
              <img
                src={`${BaseUrl.defaults.baseURL}/productimage/${selectedVideo.image}`}
                className="modal-thumb"
              />
              <h3 style={{ color: "black" }}>{selectedVideo.title}</h3>

              <a
                href={`${BaseUrl.defaults.baseURL}/product/${selectedVideo.id}`}
                style={{
                  marginTop: "8px",
                  padding: "10px 14px",
                  borderRadius: 10,
                  background: "linear-gradient(90deg, var(--accent), #3ee08a)",
                  color: "#021013",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                View Product
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoGrid;
